import { HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs';
import { ApiResponseError } from '../api-model';
import { ApiService } from './api.service';
import { RequestOptionsType } from './api.interface';

export class ApiMockService extends ApiService {

  public override request<T>(endpointName: string, method: string = 'get', options?: RequestOptionsType) {
    return super.request<any>(endpointName, method, options).pipe(
      map((response: any) => {
        if (response?.__mockError) {
          const { status, message, code } = response.__mockError;
          throw new ApiResponseError(message ?? 'Mock Error', code ?? status, status, response.__mockError);
        }
        return response as T;
      }),
      catchError((error: ApiResponseError) => {
        // On 404, retry without query params (date-based params can't be static files)
        if (error.httpStatus === 404 && options?.params) {
          const fallbackOptions = { ...options, params: undefined };
          return super.request<T>(endpointName, method, fallbackOptions);
        }
        throw error;
      })
    );
  }

  protected override path2Url(path: string, options: RequestOptionsType = {}): string {
    path = this.interpolatePath(path, options?.urlParams ?? {});

    let paramsList = [];
    const paramsStr = options?.params instanceof HttpParams
      ? options?.params.toString()
      : (new HttpParams({ fromObject: options?.params })).toString();

    if (paramsStr) {
      path += '/' + paramsStr;
    }

    let returnPath = `${ this.apiUrl }/${ path }.json`;

    console.log('returnPath', returnPath);

    return returnPath;
  }
}
